<template>
  <div class="device-detail-fault-page">
    <!-- <img src="/static/images/device/gzfx.png" class="titl"> -->
    <div class="chart-block">
      <div class="item">
        <div class="chart-box">
          <v-chart :options="options_gz" />
        </div>
      </div>
      <div class="item">
        <div class="chart-box">
          <div class="total">停机总时长：<span class="txt"><span>20</span>min</span></div>
          <v-chart :options="options_tjscfx" />
        </div>
      </div>
      <div class="item">
        <div class="chart-box">
          <div class="tab-switch">
            <span v-for="item in tabData" :class="[{'current': tabKey==item}]" v-text="item" @click="tabSwitch(item)"></span>
          </div>
          <div class="total">停机总次数：<span class="txt"><span>24</span>次</span></div>
          <v-chart :options="options_tjplfx" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  data() {
    let tabData = ['日', '周', '月'];
    let todayTime = (new Date(new Date().setHours(0, 0, 0, 0)).getTime()) / 1000;  //今天0点时间戳秒
    return {
      tabData: tabData,
      tabKey: tabData[0],
      gzList: [],
      options_gz: {},
      tjscfxList: [],
      options_tjscfx: {},
      tjplfxList: [],
      options_tjplfx: {},
      StartDate: this.$formatDateTime(todayTime - 3600*24, 'yyyy-MM-dd'),
      EndDate: this.$formatDateTime(null, 'yyyy-MM-dd'),
    }
  },
  mounted() {
    //定义全局方法
    window.gbfc_resetData = this.resetData;
    //初始化
    this.$initPage(this);
  },
  methods: {
    resetData(optionStr) {
      if(optionStr) {
        let options = JSON.parse(optionStr);
        if(options.StartDate) {
          this.StartDate = options.StartDate;
        }
        if(options.EndDate) {
          this.EndDate = options.EndDate;
        }
        console.log('options', options)
      }
      //故障
      this.getGzList();
      //停机时长分析
      this.getTjscfxList();
      //停机频率分析
      this.getTjplfxList();
    },
    tabSwitch(item) {
      console.log(item)
      this.tabKey = item;
      this.getGzhzList();
    },
    getGzList(){
      let self = this;
      this.gzList = [
        {
          TaskType: '机械故障',
          Count: 400
        },
        {
          TaskType: '电气故障',
          Count: 50
        },
        {
          TaskType: '来料故障',
          Count: 450
        },
        {
          TaskType: '软件故障',
          Count: 100
        },
      ];
      this.setOptionsGz();
    },
    setOptionsGz() {
      let colors = this.$charts.colors.style_9;
      let chartsConf = this.$charts[window.CurrentTheme];
      let legendData = [];
      let sdata = [];
      this.gzList.forEach( function(d, di) {
        legendData.push(d.TaskType);
        let tmp = {
          value: d.Count,
          name: d.TaskType,
          label: {
            normal: {
                rich: {
                  hr: {
                    borderColor: colors[di]
                  },
                  per: {
                    color: colors[di]
                  }
                }
            }
          },
          itemStyle:{
            normal:{
              color: colors[di]
            }
          }
        };
        sdata.push(tmp);
      });

      this.options_gz = {
        /*legend: {
            x : 'center',
            y : 'bottom',
            textStyle: {
              color: "#a1e1ff",
              fontSize: 24
            },
            data: legendData
        },*/
        series: [
          {
            type:'pie',
            radius: ['24%', '42%'],
            //center : ['50%', '45%'],
            //avoidLabelOverlap: true,
            labelLine: {
              //length: 30,
              length2: 20
            },
            label: {
              normal: {
                  formatter: '{per|{d}%} \n{hr|}\n {b|{b}}',
                  backgroundColor: chartsConf.series.backgroundColor,
                  padding: [6, 10, 6, 10],
                  borderColor: chartsConf.series.borderColor,
                  borderWidth: 1,
                  rich: {
                    /*hr: {
                      //borderColor: '#fff',
                      width: '100%',
                      borderWidth: 0.5,
                      height: 0,
                    },*/
                    b: {
                      fontSize: 20,
                      color: chartsConf.series.color,
                      //padding: [0, 0, 0, 0]
                    },
                    per: {
                      align: 'center',
                      fontSize: 20,
                      //padding: [0, 0, 0, 0]
                    }
                  }
              }
            },
            data: sdata
          }
        ]
      };
    },
    getTjscfxList(){
      let self = this;
      this.tjscfxList = [
        {
          TaskType: '烟包破损',
          Count: 400
        },
        {
          TaskType: '垛型问题',
          Count: 50
        },
        {
          TaskType: '烟箱问题',
          Count: 450
        },
        {
          TaskType: '机器人吸嘴破损',
          Count: 100
        },
      ];
      this.setOptionsTjscfx();
    },
    setOptionsTjscfx() {
      let colors = this.$charts.colors.style_10;
      let chartsConf = this.$charts[window.CurrentTheme];
      let legendData = [];
      let sdata = [];
      this.tjscfxList.forEach( function(d, di) {
        legendData.push(d.TaskType);
        let tmp = {
          value: d.Count,
          name: d.TaskType,
          label: {
            normal: {
                rich: {
                  hr: {
                    borderColor: colors[di]
                  },
                  per: {
                    color: colors[di]
                  }
                }
            }
          },
          itemStyle:{
            normal:{
              color: colors[di]
            }
          }
        };
        sdata.push(tmp);
      });

      this.options_tjscfx = {
        title: {
          text: '停机时长分析',
          x: 'left',
          textStyle: {
            color: chartsConf.title.color,
            fontSize: 30
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: "{b} : {c} ({d}%)",
          textStyle: {
            fontSize: 24
          }
        },
        legend: {
            orient: 'vertical',
            type: 'scroll',
            right: 0,
            top: 80,
            bottom: 0,
            textStyle: {
              color: chartsConf.legend.color,
              fontSize: 24
            },
            data: legendData
        },
        series: [
          {
            type:'pie',
            radius: '57%',
            center: ['21%', '55%'],
            //avoidLabelOverlap: true,
            labelLine: {
              normal: {
                show: false
              },
              //length: 30,
              length2: 40
            },
            label: {
              normal: {
                show: false,
                formatter: '{per|{d}%} \n{hr|}\n {b|{b}}',
                backgroundColor: chartsConf.series.backgroundColor,
                padding: [6, 10, 6, 10],
                borderColor: chartsConf.series.borderColor,
                borderWidth: 1,
                rich: {
                  /*hr: {
                    //borderColor: '#fff',
                    width: '100%',
                    borderWidth: 0.5,
                    height: 0,
                  },*/
                  b: {
                    fontSize: 20,
                    color: chartsConf.series.color,
                    //padding: [0, 0, 0, 0]
                  },
                  per: {
                    align: 'center',
                    fontSize: 20,
                    //padding: [0, 0, 0, 0]
                  }
                }
              }
            },
            data: sdata
          }
        ]
      };
    },
    getTjplfxList(){
      let self = this;
      this.tjplfxList = [
        {
          TaskType: '接近时间',
          Count: 400
        },
        {
          TaskType: '诊断时间',
          Count: 50
        },
        {
          TaskType: '更换或修理时间',
          Count: 450
        },
        {
          TaskType: '验证时间',
          Count: 100
        },
        {
          TaskType: '校准时间',
          Count: 50
        },
      ];
      this.setOptionsTjplfx();
    },
    setOptionsTjplfx() {
      let colors = this.$charts.colors.style_11;
      let chartsConf = this.$charts[window.CurrentTheme];
      let legendData = [];
      let sdata = [];
      this.tjplfxList.forEach( function(d, di) {
        legendData.push(d.TaskType);
        let tmp = {
          value: d.Count,
          name: d.TaskType,
          label: {
            normal: {
                rich: {
                  hr: {
                    borderColor: colors[di]
                  },
                  per: {
                    color: colors[di]
                  }
                }
            }
          },
          itemStyle:{
            normal:{
              color: colors[di]
            }
          }
        };
        sdata.push(tmp);
      });

      this.options_tjplfx = {
        title: {
          text: '停机频率分析',
          x: 'left',
          textStyle: {
            color: chartsConf.title.color,
            fontSize: 30
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: "{b} : {c} ({d}%)",
          textStyle: {
            fontSize: 24
          }
        },
        legend: {
            orient: 'vertical',
            type: 'scroll',
            right: 0,
            top: 80,
            bottom: 0,
            textStyle: {
              color: chartsConf.legend.color,
              fontSize: 24
            },
            data: legendData
        },
        series: [
          {
            type:'pie',
            radius: '57%',
            center: ['21%', '55%'],
            //avoidLabelOverlap: true,
            labelLine: {
              normal: {
                show: false
              },
              //length: 30,
              length2: 40
            },
            label: {
              normal: {
                show: false,
                formatter: '{per|{d}%} \n{hr|}\n {b|{b}}',
                backgroundColor: chartsConf.series.backgroundColor,
                padding: [6, 10, 6, 10],
                borderColor: chartsConf.series.borderColor,
                borderWidth: 1,
                rich: {
                  /*hr: {
                    //borderColor: '#fff',
                    width: '100%',
                    borderWidth: 0.5,
                    height: 0,
                  },*/
                  b: {
                    fontSize: 20,
                    color: chartsConf.series.color,
                    //padding: [0, 0, 0, 0]
                  },
                  per: {
                    align: 'center',
                    fontSize: 20,
                    //padding: [0, 0, 0, 0]
                  }
                }
              }
            },
            data: sdata
          }
        ]
      };
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/xiayan/device/DeviceDetailFaultAnalysis.vue